export default {"src":"/_next/static/media/checklist.5672b0ff.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};